import authRules from '../authRules';

const viewTourSalaryLevelUpgrade = (user) => {
  const { tourSalaryUpgradeAccounting } = user.securityLevels;
  if (tourSalaryUpgradeAccounting >= authRules.viewTourSalaryLevelUpgrade.tourSalaryUpgradeAccounting) {
      return true;
  } else {
      return false;
    }
  }


export default viewTourSalaryLevelUpgrade;


// WEBPACK FOOTER //
// ./src/AuthLogic/rules/viewTourSalaryLevelUpgrade.js